import Icon from '@ant-design/icons';
import {
    Breadcrumb,
    Button, Col,
    Divider,
    Layout,
    notification,
    Row,
    Typography
} from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { ReactSortable } from "react-sortablejs";
import { stateGlobal } from './../../../../../interfaces/Global';
import {
    cardLayout,
    colBotaoSalvarOrdenacao,
    colOrdenacaoModulo
} from './GridStyle';

import axios from 'axios';
import { FaCogs } from 'react-icons/fa';
import { useHistory } from 'react-router';
import { urlConfigOrdenacaoModulos, urlIconeModuloImagem, urlModulo } from '../../../../../services/request/urls';
import { getToken } from '../../../../../services/token';

import { IModulosArr, IModulosOrdenacaoArr, IModulosOrdenacaoArrMerged } from './interface';

const IconCogs = (props: any) => <Icon {...props} component={FaCogs} ></Icon>;

const { Title, Text } = Typography;

const Ordenacao: React.FC = () => {

    const propsState = useSelector((state: stateGlobal) => state.global);

    const refDadosObj = useRef<any>(null);

    const history = useHistory();

    const [loadingTable, setLoadingTable] = useState(false);
    const [dadosObj, setDadosObj] = useState<Array<IModulosOrdenacaoArrMerged>>([]);

    //executa apenas ao iniciar o component
    useEffect(() => {

        setLoadingTable(true)

        const verificaSeDadosFuncEIgual = async () => {
            try {

                let arrModulosReq = await axios.get(urlModulo,
                    { headers: { 'Authorization': 'Bearer ' + getToken() } });

                let result = await axios.get(urlConfigOrdenacaoModulos,
                    { headers: { 'Authorization': 'Bearer ' + getToken() } });

                const modulosMap = new Map();
                arrModulosReq.data.forEach((modulo: IModulosArr) => {
                    modulosMap.set(modulo.path, modulo);
                });

                const mergedResult = result.data.map((elem: IModulosOrdenacaoArr) => {
                    const correspondingModule = modulosMap.get(elem.func);

                    if (correspondingModule) {
                        return {
                            ...elem,
                            ...correspondingModule,
                        };
                    } else {
                        return { ...elem };
                    }
                });

                setDadosObj(mergedResult)

            } catch (error) {

            }
        }

        verificaSeDadosFuncEIgual();

    }, []);

    const onClickVoltarConfigOfSystem = useCallback((): void => {
        history.push("/configuracoesdosistema");
    }, []);

    useEffect(() => {
        refDadosObj.current = dadosObj

    }, [dadosObj]);

    //executa apenas quando salvar
    const salvarDados = useCallback(() => {
        setLoadingTable(true)
        const buscaDeDados = async () => {
            try {

                await axios.post(urlConfigOrdenacaoModulos,
                    refDadosObj.current,
                    { headers: { 'Authorization': 'Bearer ' + getToken() } });


                notification.success({
                    message: 'Sucesso',
                    description:
                        'Seus dados foram salvos com sucesso!',
                });
                setLoadingTable(false);
                onClickVoltarConfigOfSystem();

            } catch (error) {

                let msgErro: any = (error as Error);
                setLoadingTable(false)
                notification.error({
                    message: 'Erro',
                    description:
                        msgErro?.response?.data?.message ? msgErro?.response?.data?.message : 'Não foi possivel salvar!',
                });
            }
        }

        buscaDeDados();

    }, []);

    return (
        <>
            <Layout style={{ margin: -25 }}>
                <div style={{
                    backgroundColor: propsState.theme === 'light' ? '#fff' : '#141414',
                    padding: 22
                }}>
                    <Row>
                        <Col {...cardLayout}>
                            <Title level={3}><IconCogs style={{ fontSize: 35 }} /> Configurações do Sistema</Title>
                            <Breadcrumb>
                                <Breadcrumb.Item><a onClick={onClickVoltarConfigOfSystem}>Configurações do Sistema</a></Breadcrumb.Item>
                                <Breadcrumb.Item>Módulo Ordenação</Breadcrumb.Item>
                            </Breadcrumb>
                            <Divider style={{
                                marginBottom: 10
                            }} />
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-end'
                        }} {...colBotaoSalvarOrdenacao}>
                            <Button
                                key="submit"
                                type="primary"
                                style={{
                                    marginBottom: 10
                                }}
                                // loading={loadingFormAdd}
                                onClick={salvarDados}
                            >
                                Salvar
                            </Button>
                        </Col>
                    </Row>
                </div>
                <Row>
                    <Col {...colBotaoSalvarOrdenacao}>

                        <ReactSortable
                            style={{
                                // display: 'grid',
                                // gridColumnGap: 20,
                                // gridTemplateColumns: 'auto auto',
                                // backgroundColor: '#ccc',
                                // padding: 5
                            }}
                            list={dadosObj}
                            setList={setDadosObj}
                            animation={150}
                            className='ant-row'
                        >
                            {dadosObj.map((item, index) => (
                                <Col key={'colun' + index} style={{
                                    marginLeft: 17,
                                    borderRadius: 8,
                                    backgroundColor: propsState.theme === 'light' ? '#fff' : '#141414',
                                    boxShadow: '4px 4px 4px 4px rgba(0, 0, 0, 0.2)',
                                    marginTop: '3%',
                                    padding: 10,
                                }} {...colOrdenacaoModulo}>

                                    <div style={{
                                        flexDirection: 'row',
                                    }}>
                                        <img style={{
                                            width: 50,
                                        }} src={urlIconeModuloImagem + item.icone?.file} ></img>

                                    </div>
                                    <div style={{ width: '100%' }}>
                                        <Text strong type="secondary" style={{
                                            // fontStyle: 'normal',
                                            // fontWeight: 'bold',
                                            fontSize: 13,
                                            // lineHeight: 16,
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginTop: 8
                                        }}>
                                            {item.nome}
                                        </Text>
                                    </div>
                                </Col>
                            ))}
                        </ReactSortable>
                    </Col>
                </Row>
            </Layout>
        </>
    );
}

export default Ordenacao;
